import { ItandiHeader } from "@itandi/brand-ui/ItandiHeader";
import Link from "next/link";
import { useRouter } from "next/router";
import type { ComponentProps } from "react";
import { useSessions } from "~/hooks/vendors/useSessions";
import { PATH as ADMIN_VENDOR_COMPANIES_PATH } from "~/pages/admin/vendor_companies";

import { PATH as VENDOR_HOME_PATH } from "~/pages/vendors";
import { PATH as VENDOR_DEALS_PATH } from "~/pages/vendors/deals";
import { PATH as VENDOR_LOGIN_PATH } from "~/pages/vendors/login";
import { PATH as VENDOR_MESSAGES_PATH } from "~/pages/vendors/messages";
import { PATH as VENDOR_SETTINGS_PATH } from "~/pages/vendors/settings";
import { destroy as logout } from "~/utils/api/vendors/sessions/VendorCompany";

export const VendorHeader: React.FC = () => {
	const router = useRouter();
	const { data: session } = useSessions().index();
	if (session === null) return null;

	const handleVendorLogout = async (): Promise<void> => {
		await logout();
		await router.push(VENDOR_LOGIN_PATH);
	};

	const isActivePage = (currentPath: string, targetPath: string): boolean => {
		if (targetPath === "/vendors") return currentPath === "/vendors";
		return currentPath.includes(targetPath);
	};

	const menus = [
		{
			active: isActivePage(router.pathname, VENDOR_HOME_PATH),
			as: Link,
			href: VENDOR_HOME_PATH,
			kind: "link",
			label: "ダッシュボード"
		},
		{
			active: isActivePage(router.pathname, VENDOR_DEALS_PATH),
			as: Link,
			href: VENDOR_DEALS_PATH,
			kind: "link",
			label: "案件一覧"
		},
		{
			active: isActivePage(router.pathname, VENDOR_MESSAGES_PATH),
			as: Link,
			href: VENDOR_MESSAGES_PATH,
			kind: "link",
			label: "チャット"
		},
		{
			active: isActivePage(router.pathname, VENDOR_SETTINGS_PATH),
			as: Link,
			href: VENDOR_SETTINGS_PATH,
			kind: "link",
			label: "設定"
		},
		session.admin
			? {
					active: false,
					as: Link,
					href: ADMIN_VENDOR_COMPANIES_PATH,
					kind: "link",
					label: "Admin"
				}
			: null,
		{
			as: Link,
			href: "https://itandibb.support.itandi.co.jp/hc/ja",
			isExternalLink: true,
			kind: "link",
			label: "ヘルプ"
		}
	] as const satisfies ComponentProps<typeof ItandiHeader>["menus"];

	const productMenus = [
		{
			code: "nsk",
			url: "" // ページ遷移なし
		}
	] as const satisfies ComponentProps<typeof ItandiHeader>["productMenus"];

	const staffAccount = {
		name: session.vendorUser?.name || session.vendorCompany.name
	} as const satisfies ComponentProps<typeof ItandiHeader>["staffAccount"];

	return (
		<ItandiHeader
			isAdmin={session.admin}
			itandiAccount={undefined} // 施工会社はイタンジアカウントを持たない
			logout={handleVendorLogout}
			menus={menus}
			productCode="nsk"
			productMenus={productMenus}
			staffAccount={staffAccount}
		/>
	);
};
